export function useOrientation() {
    const isPortrait = window.innerHeight > window.innerWidth;
    return isPortrait;
}